import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { DashBoard } from '../../pages/DashBoard/DashBoard';
import { Login } from '../../pages/Login/Login';
import ProtectedRoute from '../ProtectedRoute';
import { Users } from '../../pages/Users/Users';
import { Admins } from '../../pages/Admins/Admins';
import { Settlement } from '../../pages/Settlement/Settlement';
import { Logs } from '../../pages/Logs/Logs';
import { LoginLogs } from '../../pages/LoginLogs/LoginLogs';
import { QuotaUsageLog } from '../../pages/QuotaUsageLog/QuotaUsageLog';
import { Settings } from '../../pages/Settings/Settings';
import { Notices } from '../../pages/Notices/Notices';
import { UpdatePosts } from '../../pages/UpdatePosts/UpdatePosts';

const Layout = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <DashBoard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <Users />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/users"
                element={
                    <ProtectedRoute>
                        <Users />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admins"
                element={
                    <ProtectedRoute>
                        <Admins />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/loginlogs"
                element={
                    <ProtectedRoute>
                        <LoginLogs />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/logs"
                element={
                    <ProtectedRoute>
                        <Logs />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/QuotaUsageLog"
                element={
                    <ProtectedRoute>
                        <QuotaUsageLog />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/settlement"
                element={
                    <ProtectedRoute>
                        <Settlement />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/settings"
                element={
                    <ProtectedRoute>
                        <Settings />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/notices"
                element={
                    <ProtectedRoute>
                        <Notices />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/update-posts"
                element={
                    <ProtectedRoute>
                        <UpdatePosts />
                    </ProtectedRoute>
                }
            />
            <Route path="*" element={<Navigate to="/users" replace />} />
        </Routes>
    );
};
export default Layout;
